import * as React from 'react'
import { KEYS } from 'platejs'
import { useEditorSelector } from 'platejs/react'

import { LinkIcon } from '../../../icons'
import { RichTextField } from '../../RichTextField'

type LinkToolbarButtonProps = Omit<
  React.ComponentPropsWithoutRef<typeof RichTextField.ToolbarButton>,
  'children' | 'label'
>

const LinkToolbarButton = React.forwardRef<
  HTMLButtonElement,
  LinkToolbarButtonProps
>((props, ref) => {
  const pressed = useEditorSelector(
    (editor) => editor.api.some({ match: { type: editor.getType(KEYS.link) } }),
    [],
  )

  return (
    <RichTextField.ToolbarButton
      {...props}
      ref={ref}
      aria-pressed={pressed}
      label="Link"
    >
      <LinkIcon />
    </RichTextField.ToolbarButton>
  )
})

LinkToolbarButton.displayName = 'RichTextField.LinkToolbarButton'

export { LinkToolbarButton }
export type { LinkToolbarButtonProps }
